module.exports = __webpack_public_path__ + "static/media/solution-selection-large@3x.5af8f2ec.png";